import React from 'react';


const SecurePopup = props => {
  return(
      <div className={`secure-popup ${props.secureLocation}`}>
        <div className="row secure-wrapper">
          <div className="column small-12">
            <p className="secure-text">
              We use secure payment platform to process bookings. Look out
  for the green lock or domain with HTTPS in the URL address bar.
            </p>
            <div className="secure-bar">
              <div className="row secure-wrapper">
                <div className="column small-12">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-674 -2620 16 18.286">
                      <path d="M14.286,8h-.857V5.429a5.429,5.429,0,0,0-10.857,0V8H1.714A1.715,1.715,0,0,0,0,9.714v6.857a1.715,1.715,0,0,0,1.714,1.714H14.286A1.715,1.715,0,0,0,16,16.571V9.714A1.715,1.715,0,0,0,14.286,8ZM10.571,8H5.429V5.429a2.571,2.571,0,0,1,5.143,0Z" transform="translate(-674 -2620)"/>
                    </svg>
                    <span className="divider">|</span>
                    <span>https</span><span className="link-text">://book.busabout.com/</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  )
}

export default React.memo(SecurePopup);



// WEBPACK FOOTER //
// ./src/components/shared/securePopup.js